// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"logo-link-module--logo-link--2hgbO"};